import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import { Row, Col, Input, Button } from 'bootstrap';
import ModalActions from 'shared/flux/actions/ModalActions';
import PDFExportFormActions from 'shared/flux/actions/cuesheet.printable/PDFExportFormActions';
import UIRegions from 'shared/constants/UIRegions';

/**
 * Create PDF Preset Modal
 */
export default React.createClass({
  mixins: [Reflux.ListenerMixin],

  displayName: 'PDFPresetForm',

  getInitialState() {
    return {
      title: '',
    };
  },

  componentWillMount() {
    this.listenTo(
      PDFExportFormActions.createNewPreset.completed,
      'onPresetCreateCompleted',
    );
  },

  componentDidUpdate() {
    this.refs.presetTitle.getInputDOMNode().focus();
  },

  render() {
    const { title } = this.state;

    const buttonClasses = classNames('btn-save', {
      inactive: !title.length > 0,
    });

    return (
      <div>
        <Row>
          <Col md={24}>
            <p>
              This preset will include the export settings that you currently
              have selected.
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Input
              type="text"
              placeholder="Preset name..."
              value={title}
              autoFocus
              onKeyDown={(e) => this._handleKeyPress(e)}
              onChange={(e) => this._handleInputChange(e.target.value)}
              ref="presetTitle"
            />
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Button onClick={this._handleSubmit} className={buttonClasses}>
              Create preset
            </Button>
          </Col>
        </Row>
      </div>
    );
  },

  _handleKeyPress(e) {
    if (e.keyCode === 13) this._handleSubmit();
  },

  _handleInputChange(value) {
    this.setState({ title: value });
  },

  _handleSubmit() {
    const { title } = this.state;

    if (title.length > 0) {
      PDFExportFormActions.submitNewPreset(title);
      this.setState({ title: '' });
    }
  },

  onPresetCreateCompleted() {
    ModalActions.hide(UIRegions.CreatePDFPresetModal);
  },
});
